import { render, staticRenderFns } from "./WpUserActivityLog.vue?vue&type=template&id=53356160&"
import script from "./WpUserActivityLog.vue?vue&type=script&lang=js&"
export * from "./WpUserActivityLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports